import type { TranslationTable } from "./useTranslate";

/* Telemundo */
export const ClientCodeTelemundoTranslationTable: TranslationTable = {
	Job: { es: "Producción", fr: "Production" },
	Checkout: {
		en: "Quote Request",
		es: "Solicitud de presupuesto",
		fr: "Demande de devis",
	},
};
